export const FLAG_CONFIRMED_BAD = 'confirmed';
export const FLAG_FALSE_POSITIVE = 'false_positive';
